export const GROUPS_COLLECTION = 'groups';
export const INVITED_COLLECTION = 'invited';

/** Nombre maximum de groupes acceptés sur un même créneau */
export const MAX_GROUPS_PER_SLOT = 12;

/** Seuil d'invités au-delà duquel le groupe est signalé en rouge */
export const GUESTS_WARNING_THRESHOLD = 10;

/** Durée d'un créneau de visite, en minutes */
export const SLOT_DURATION_MINUTES = 150;

/** Élément de programme sélectionné (chaîne brute ou objet avec libellé) */
export type ProgramItem =
  | string
  | { _id?: string; label?: string; name?: string; title?: string; value?: string };

export interface Group {
  _id: string;
  privateKey: string;
  collection: string;
  /** Participant à l'origine des invitations (l'invitant) */
  parentId?: string;
  name?: string;
  /** Nom de l'invitant saisi à la main (indépendant du participant lié) */
  inviterName?: string;
  /** Format "YYYY-MM-DD HH:mm" */
  slot?: string;
  guide?: string;
  /** Démonstrations sélectionnées (multiselect) */
  demos?: ProgramItem[];
  /** Conférences sélectionnées (multiselect) */
  conferences?: ProgramItem[];
  createdAt: string;
  updatedAt: string;
}

export interface Invited {
  _id: string;
  collection: string;
  /** Groupe auquel l'invité appartient */
  parentId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  /** Statut d'inscription ; `registered` = l'invité a validé */
  status?: string;
  /** L'invité a demandé un accès PMR */
  pmr?: 'yes' | 'no';
  /** L'invité a demandé une place de parking */
  parking?: 'yes' | 'no';
  /** Plaque d'immatriculation (si parking demandé) */
  licensePlate?: string;
}

/** Un groupe enrichi de ses invités et de ses statistiques */
export interface GroupWithInvited extends Group {
  invited: Invited[];
  /** Nombre total d'invités du groupe */
  totalCount: number;
  /** Nombre d'invités qui ont confirmé (status === 'registered') */
  registeredCount: number;
  /** Nombre d'invités qui ont refusé (status === 'refused') */
  refusedCount: number;
  /** Nombre d'invités en attente de réponse (ni confirmé ni refusé) */
  pendingCount: number;
  /** Nombre d'invités ayant demandé un accès PMR */
  pmrCount: number;
  /** Nombre d'invités ayant demandé une place de parking */
  parkingCount: number;
}
